import { render, staticRenderFns } from "./RiskCevaplari.vue?vue&type=template&id=015a0386"
import script from "./RiskCevaplari.vue?vue&type=script&lang=js"
export * from "./RiskCevaplari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports